<template>
  <header class="h-64 bg-primary-pure flex items-center px-24 w-full shrink-0">
    <div class="mr-24">
      <h4 class="text-headline-1 text-white">
        {{ title }}
      </h4>
    </div>

    <q-space />
    <slot />

    <OButtonRounded
      class="text-white bg-white/10 !size-44 !rounded-lg"
      @click="emit('click:close')"
    />
  </header>
</template>

<script setup>
import OButtonRounded from 'components/Button/OButtonRounded.vue'

const props = defineProps({
  title: String,
})

const emit = defineEmits(['click:close'])
</script>

<style lang="scss" scoped></style>
